import gql from 'graphql-tag'

export const SAVE_PAGE = gql`
    mutation savePage($input: SavePageInput!) {
        savePage(input: $input) {
            page {
                id
                parentPageIdentifier
                sortIndex
                deactivated
                isTemplate
                isStartPage
                createdAt
                updatedAt
                lastPublished
                currentVersion {
                    id
                    state
                    pageID
                    contents
                    createdAt
                    updatedAt
                    updatedBy {
                        id
                        name
                    }
                    pageSettings {
                        htmlTitle
                        urlTitle
                        metaDescription
                        metaKeywords
                        robotsOption
                        includeInSitemapXML
                        pageRank
                        changeFrequency
                        language
                        translationID
                    }
                }
            }
            linkedPages {
                id
                parentPageIdentifier
                sortIndex
                deactivated
                isTemplate
                isStartPage
                createdAt
                updatedAt
                currentVersion {
                    id
                    state
                    pageID
                    contents
                    createdAt
                    updatedAt
                    updatedBy {
                        id
                        name
                    }
                    pageSettings {
                        htmlTitle
                        urlTitle
                        metaDescription
                        metaKeywords
                        robotsOption
                        includeInSitemapXML
                        pageRank
                        changeFrequency
                        language
                        translationID
                    }
                }
            }
        }
    }
`
